// Consolidated HQ billing (admins + managers). Batches, deposit/balance recording, company settings.
import { api } from './client.js';

export const fetchCompanyBatches = (companyId) => api.get(`/billing/companies/${companyId}/batches`).then((r) => r.data);
export const fetchEligibleOrders = (companyId) => api.get(`/billing/companies/${companyId}/eligible-orders`).then((r) => r.data);
export const setCompanyBilling = (companyId, body) => api.post(`/billing/companies/${companyId}/settings`, body).then((r) => r.data);

export const createBatch = (body) => api.post('/billing/batches', body).then((r) => r.data);
export const fetchBatch = (id) => api.get(`/billing/batches/${id}`).then((r) => r.data);
export const recordBatchDeposit = (id, body) => api.post(`/billing/batches/${id}/deposit`, body).then((r) => r.data);
export const recordBatchBalance = (id, body) => api.post(`/billing/batches/${id}/balance`, body).then((r) => r.data);
export const cancelBatch = (id) => api.post(`/billing/batches/${id}/cancel`, {}).then((r) => r.data);
export const notifyRepOfBatch = (id) => api.post(`/billing/batches/${id}/notify-rep`, {}).then((r) => r.data);
